import React from 'react';
import { Outlet } from 'react-router-dom';

import { Navbar } from '../../components/Navbar';

/**
 * The site header over every team page (marketing, operations, sales), as on the landing page and the rest of the
 * app. A route layout rather than part of `TeamRecordsLayout`, so pages render (and test) without the auth modal.
 */
export const TeamAppFrame: React.FC = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);
